// @greenlight-spec: 20-agent-plugins.md
// @greenlight-spec: 28-it-dashboard-ui.md

import { PLUGIN_MARKETPLACE_NAME } from '@greenlight/shared';

/** Copilot enterprise managed settings that register this marketplace and auto-install Greenlight. */
export function buildCopilotManagedSettings(marketplaceRepo: string): Record<string, unknown> {
  return {
    extraKnownMarketplaces: {
      [PLUGIN_MARKETPLACE_NAME]: {
        source: { source: 'github', repo: marketplaceRepo },
      },
    },
    enabledPlugins: { [`greenlight@${PLUGIN_MARKETPLACE_NAME}`]: true },
  };
}

/** Managed `permissions.allow` rules: the greenlight command and this install's host run without a prompt. */
export function buildCopilotPermissions(mcpUrl: string): Record<string, unknown> {
  return {
    permissions: { allow: ['Shell(greenlight *)', `Domain(${new URL(mcpUrl).host})`] },
  };
}

/** Matcher to add to `allowedMcpServers` when that allowlist is already in use. */
export function buildCopilotMcpAllowlistMatcher(
  mcpUrl: string,
): ReadonlyArray<{ serverUrl: string }> {
  return [{ serverUrl: mcpUrl }];
}

export function formatCopilotSettingsJson(settings: unknown): string {
  return JSON.stringify(settings, null, 2);
}
